import type { LiveTradeResponse } from 'apiConnector/secondary-market/live/models';
import { secondaryMarketOriginalFormActionsFactory } from 'state/secondaryMarket/shared/form/original/original.actions';

export const liveOriginalFormActions = secondaryMarketOriginalFormActionsFactory<'LIVE', LiveTradeResponse>('LIVE');
type TypeofLiveOriginalFormActions = typeof liveOriginalFormActions;
export type SecondaryMarketAmendLiveFetchRequested = ReturnType<
  TypeofLiveOriginalFormActions['secondaryMarketAmendFetchRequested']
>;
export type SecondaryMarketAmendLiveFetched = ReturnType<TypeofLiveOriginalFormActions['secondaryMarketAmendFetched']>;
export type SecondaryMarketAmendLiveFetchFailed = ReturnType<
  TypeofLiveOriginalFormActions['secondaryMarketAmendFetchFailed']
>;
export type SecondaryMarketLiveOriginalFormActions = ReturnType<
  TypeofLiveOriginalFormActions[keyof TypeofLiveOriginalFormActions]
>;
